import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

interface InactiveContentProps {
  flexDirection: 'row' | 'col'
  className?: string
}

const INACTIVE_CONTENT_STYLES =
  'flex text-blankslateinactivecontent text-center font-body'

export const InactiveContent: React.FC<PropsWithChildren<
  InactiveContentProps
>> = ({ flexDirection = 'row', children, className }) => {
  const direction = flexDirection === 'row' ? 'flex-row' : 'flex-col'
  const padding = flexDirection === 'row' ? 'py-2 px-4' : 'p-8'

  return (
    <div
      className={concatStyles([
        INACTIVE_CONTENT_STYLES,
        direction,
        padding,
        className,
      ])}
    >
      {children}
    </div>
  )
}

InactiveContent.displayName = 'Content.InactiveContent'
